import e, { css as t } from "styled-components";
const r = e.div.withConfig({
  displayName: "Icon",
  componentId: "sc-up63cb-0"
})(["align-items:center;display:flex;justify-content:center;", " ", ""], ({
  color: n
}) => t(["fill:", ";"], n != null ? n : "currentColor"), ({
  $size: n
}) => t(["height:", ";max-height:", ";max-width:", ";min-height:", ";min-width:", ";width:", ";"], typeof n == "number" ? n : `var(--size-icon-${n})`, typeof n == "number" ? n : `var(--size-icon-${n})`, typeof n == "number" ? n : `var(--size-icon-${n})`, typeof n == "number" ? n : `var(--size-icon-${n})`, typeof n == "number" ? n : `var(--size-icon-${n})`, typeof n == "number" ? n : `var(--size-icon-${n})`)), i = e.div.withConfig({
  displayName: "IconGroup",
  componentId: "sc-up63cb-1"
})(["align-items:center;display:flex;flex-direction:row;flex-wrap:wrap;gap:2rem;"]);
export {
  r as Icon,
  i as IconGroup
};
//# sourceMappingURL=style.es.js.map
